import { Tooltip } from 'antd';
import clsx from 'classnames';
import { FC, HTMLAttributes } from 'react';

import countries from '../../countries.json';

import styles from './styles.module.less';

const countriesByCode = Object.fromEntries(
  countries.map((country) => [country['code'], country]),
);

type CountryFlagProps = HTMLAttributes<HTMLSpanElement> & {
  code: string;
  tooltip?: boolean;
};

const CountryFlag: FC<CountryFlagProps> = ({
  className,
  code: countryCode,
  tooltip,
  ...rest
}) => {
  const country = countriesByCode[countryCode === 'UK' ? 'GB' : countryCode];

  if (!country) {
    return null;
  }

  const icon = (
    <img
      alt={country.code}
      className={clsx(styles.root, className)}
      src={`https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/${country.code.toLowerCase()}.svg`}
      {...rest}
    />
  );

  if (tooltip) {
    return <Tooltip title={country.name}>{icon}</Tooltip>;
  }

  return icon;
};

CountryFlag.displayName = 'CountryFlag';

export default CountryFlag;
